/* Barra delgada de suscripción para móvil (reemplaza el disparo automático del popup).
   - Solo en móvil (<750px). En desktop el popup sigue con su retardo y exit-intent.
   - No aparece en fichas, carrito ni checkout: ahí no compite con "Agregar al carrito".
   - Al tocarla abre el popup existente (<subscribe-popup>): apertura iniciada por el usuario,
     que Google no considera interstitial intrusivo.
   - Respeta las mismas claves de localStorage del popup (suscrito / cerrado hace < 15 días). */
(function () {
  "use strict";
  if (window.__fbSubscribeBar) return;
  window.__fbSubscribeBar = true;

  var LS_SUBSCRIBED = "fb_subscribed",
    LS_DISMISSED = "fb_subscribe_dismissed_at",
    SUPPRESS_DAYS = 15,
    DAY_MS = 864e5,
    SHOW_AFTER_SCROLL = 0.25;

  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return "1"; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }

  function eligible() {
    if (!window.matchMedia("(max-width: 749px)").matches) return false;
    if (/^\/(products|cart|checkout|challenge|account)/.test(window.location.pathname)) return false;
    if (lsGet(LS_SUBSCRIBED) === "1") return false;
    var dismissed = parseInt(lsGet(LS_DISMISSED), 10);
    if (dismissed && Date.now() - dismissed < SUPPRESS_DAYS * DAY_MS) return false;
    return !!document.querySelector("subscribe-popup");
  }

  function build() {
    var bar = document.createElement("div");
    bar.className = "fb-subscribe-bar";
    bar.setAttribute("role", "region");
    bar.setAttribute("aria-label", "Descuento por suscripción");
    bar.innerHTML =
      '<button type="button" class="fb-subscribe-bar__open">' +
      '<span class="fb-subscribe-bar__text">5% dcto. en tu primera compra</span>' +
      '<span class="fb-subscribe-bar__cta">Lo quiero</span></button>' +
      '<button type="button" class="fb-subscribe-bar__close" aria-label="Cerrar">&times;</button>';

    bar.querySelector(".fb-subscribe-bar__open").addEventListener("click", function () {
      var popup = document.querySelector("subscribe-popup");
      remove(bar);
      if (popup && popup.open) popup.open();
    });
    bar.querySelector(".fb-subscribe-bar__close").addEventListener("click", function () {
      lsSet(LS_DISMISSED, String(Date.now()));
      remove(bar);
    });
    return bar;
  }

  function remove(bar) {
    document.body.classList.remove("has-fb-subscribe-bar");
    if (bar && bar.parentNode) bar.parentNode.removeChild(bar);
  }

  function init() {
    if (!eligible()) return;
    var shown = false;
    var onScroll = function () {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      if (shown || max <= 0 || window.scrollY / max < SHOW_AFTER_SCROLL) return;
      shown = true;
      window.removeEventListener("scroll", onScroll);
      document.body.appendChild(build());
      document.body.classList.add("has-fb-subscribe-bar");
    };
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
